import LoadingAction from "@common/redux/actions/LoadingAction";
import { handleError } from "@common/components/helpers/error";
import CustomerClient from "@common/api/CustomerClient";
import IncidentClient from "@common/api/IncidentClient";
import CustomerIncidentAction from "@common/redux/actions/CustomerIncidentAction";
import { formatForSelect } from "./formOptions";
import OfficerClient from "@common/api/OfficerClient";

const fetchIncidentData = (siteGuid) => {
  LoadingAction.set(true).then(() => {
    IncidentClient.MetaData(siteGuid).then(
      (response) => {
        CustomerIncidentAction.dispatch({
          customerIncidentTypes: formatForSelect(
            response.customerIncidentTypes,
          ),
          incidentType: response.types.filter((obj) => {
            return obj.name.toLowerCase().indexOf("customer incident") !== -1;
          })[0],
          incidentRecord: { ...response.record },
        });
      },
      (error) => handleError(error),
    );
    CustomerClient.MetaData()
      .then(
        (response) => {
          CustomerIncidentAction.dispatch({
            customerRecord: { ...response.record },
          });
        },
        (error) => handleError(error),
      )
      .finally(() => {
        LoadingAction.set(false);
      });
    OfficerClient.MetaData()
      .then(
        (response) => {
          CustomerIncidentAction.dispatch({
            officerRecord: { ...response.record },
            officerType: response.officerTypes.filter((obj) => {
              return obj.name.toLowerCase().indexOf("police") !== -1;
            })[0],
          });
        },
        (error) => handleError(error),
      )
      .finally(() => {
        LoadingAction.set(false);
      });
  });
};

export default fetchIncidentData;
